// Module: slideNavigationLockHook
// -----------------------------------------------------------------
// Receives:  the auto-advance lock (useNotificationStore) and the
//            manual-navigation flag (useSlideStore)
// Produces:  one boolean every student navigation control checks
// Does NOT:  take either lock (→ slideTransition.js, runManualSlideChange)
// -----------------------------------------------------------------

import { useNotificationStore } from "@/store/useNotificationStore";
import { useSlideStore } from "@/features/tutor/store/useSlideStore";

/**
 * True while a slide change is promised or under way.
 *
 * The two sources stay separate on purpose: the auto-advance lock covers the
 * tutor's countdown and its change_slide until it answers, a manual change is
 * already running.
 */
export function useIsSlideNavigationLocked(): boolean {
  const isAutoAdvanceLocked = useNotificationStore(
    (state) => state.isSlideChangeNotificationActive,
  );
  const isManualSlideChangeInFlight = useSlideStore(
    (state: { isManualSlideChangeInFlight: boolean }) =>
      state.isManualSlideChangeInFlight,
  );
  return isAutoAdvanceLocked || isManualSlideChangeInFlight;
}
